import {useEffect, useState} from 'react';
import {normalizePropertyItemsForRead} from '../utils/entityProperties.js';

const LOG_PREFIX = '[useEntityProperties]';
const BASE = (process.env.REACT_APP_AWP_API_BASE || process.env.REACT_APP_AWP_API_URL || '')
    .replace(/\/$/, '');

function authHeaders() {
    const token = localStorage.getItem('access_token');
    return token ? {'Authorization': `Bearer ${token}`} : {};
}

/**
 * Fetch entity properties from dash-api /api/entities/{entityId}/properties-doc.
 * Phase 6 replacement for Firestore `entities/{entityId}/details/properties`.
 */
export function useEntityProperties(entityId, refetchKey = 0) {
    const [properties, setProperties] = useState([]);
    const [revision, setRevision] = useState(0);
    const [loading, setLoading] = useState(!!entityId);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!entityId) {
            setProperties([]);
            setRevision(0);
            setLoading(false);
            setError(null);
            return;
        }

        setLoading(true);
        setError(null);
        console.debug(`${LOG_PREFIX} Fetching properties for entity: ${entityId}`);

        fetch(`${BASE}/api/entities/${encodeURIComponent(entityId)}/properties`, {headers: authHeaders()})
            .then((r) => r.status === 404 ? null : r.ok ? r.json() : Promise.reject(new Error(`${r.status}`)))
            .then((data) => {
                if (!data) {
                    setProperties([]);
                    setRevision(0);
                } else {
                    const items = normalizePropertyItemsForRead(data.items || []);
                    setProperties(items);
                    setRevision(Number.isInteger(data.revision) ? data.revision : 0);
                }
                setLoading(false);
            })
            .catch((err) => {
                console.error(`${LOG_PREFIX} Error:`, err);
                setError(err);
                setLoading(false);
            });
    }, [entityId, refetchKey]);

    return {properties, revision, loading, error};
}
